import styled from "styled-components";

export default styled.div`

&{
  display: flex;
  flex-direction: column;
}
div{
  flex-direction: row;
  border-radius: 8px;
  width: max-content;
  max-width: 52%;
  margin: 5px 20px 5px 20px;
  padding: 0px 45px 10px 15px;
  text-align: center;
  position:relative;
}

#message-timestamp{
  position: absolute;
  margin: 0;
  right: 5px;
  bottom: 4px;
  font-size: 0.85em;
  color: ${props => props.theme.colors.primary_light};
}

.left{
  background:${props => props.theme.colors.background_primary};
  text-align: left;
  padding-right: 50px;
}

.right{
  justify-self: flex-end;
  text-align: left;
  align-self: flex-end;
  background: ${props => props.theme.colors.background_secondary};
  background: 10px solid white;
}

.left:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 10px solid transparent;
  border-right: 10px solid ${props => props.theme.colors.background_primary};
  border-top: 10px solid ${props => props.theme.colors.background_primary};
  border-bottom: 10px solid transparent;
  left: -19px;
  top: 6px;
}
.right:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 10px solid ${props => props.theme.colors.background_secondary};
  border-right: 10px solid transparent;
  border-top: 10px solid ${props => props.theme.colors.background_secondary};
  border-bottom: 10px solid transparent;
  right: -20px;
  top: 6px;
}

.sending{
  opacity: 0.3;
}
`